import React, { useCallback, useState } from "react";
import { snakeToSpaces } from "../../utils/";
import "./Group.scss";
import FilterTree from "./FilterTree";
import Header from "./Header";
import { selectGroups } from "./utils";

// The structure of filters is displayed hierarchically, but they are
// sent to the store in a flat array.

// if a filter dimension array is empty, no filtering is done on that dimension

// TODO Rendering works recursively here but not the toggleGroup function
export const FilterGroup = ({
  className = "",
  filterKey = "",
  filterValues = [],
  selected = [],
  onChange = () => {},
  isOpen = false,
  title = "",
  description = "",
  groups = null,
}) => {
  const [showChildren, setShowChildren] = useState(isOpen);
  if (!groups)
    groups = [
      { name: "", children: [...filterValues.map((f) => ({ name: f }))] },
    ];

  const onLabelClick = useCallback(() => {
    setShowChildren((c) => !c);
  }, []);

  const resetAll = useCallback(() => {
    onChange({
      [filterKey]: {
        all: filterValues,
        selected: [],
        groups: groups, // this mutates the store ultimately
      },
    });
  }, [onChange, filterKey, filterValues, groups]);

  // TODO Make recursive to arbitrary depth
  const toggleGroup = useCallback(
    (group) => () => {
      const allGroupFilters = selectGroups(groups, group);

      const s = new Set(selected);

      const intersection = new Set(
        [...allGroupFilters].filter((x) => s.has(x))
      );
      const difference = new Set([...s].filter((x) => !allGroupFilters.has(x)));

      let o = new Set();
      if (intersection.size < allGroupFilters.size) {
        // if none selected, select all;
        // if less than all of the group's children are selected, select all;
        o = new Set([...allGroupFilters, ...selected]);
      } else {
        // if all selected, select none;
        o = difference;
      }

      onChange({
        [filterKey]: {
          all: filterValues,
          selected: [...o],
          groups: groups, // this mutates the store ultimately
        },
      });
    },
    [onChange, selected, filterKey, filterValues, groups]
  );

  return (
    <div className={`filter-group flex flex-column block-font h4 ${className}`}>
      <Header
        title={snakeToSpaces(title)}
        isExpanded={showChildren}
        onExpand={onLabelClick}
        resetChildren={resetAll}
      />
      {showChildren && (
        <div className="fade-in flex flex-wrap flex-row h4">
          <div className="flex flex-column pl2">
            <FilterTree
              data={groups}
              filterKey={filterKey}
              filterValues={filterValues}
              groups={groups}
              name={groups.name}
              path={groups.name}
              onChange={onChange}
              selected={selected}
              title={title}
              toggleGroup={toggleGroup}
            />
          </div>
        </div>
      )}
    </div>
  );
};
